import React from 'react';
import ReactDOM from 'react-dom';
import RouterLoggedOut from './routers/RouterLoggedOut';

import debugLib from 'debug';
import '../../less/loggedout/styles.less';

window.DBDebug = debugLib;
window.onload = function() {
  ReactDOM.render(<RouterLoggedOut />, document.getElementById('app'));
};
